// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import grminEntity from './entities/grmin.json';
import grminMenu from '../pages/grmin/menu.json';
import grminFullForm from '../pages/grmin/forms/full.json';
import grminContextForm from '../pages/grmin/forms/context.json';
import grminMiniForm from '../pages/grmin/forms/mini.json';
import grminLookupForm from '../pages/grmin/forms/lookup.json';
import grminTableView from '../pages/grmin/views/table.json';
import grminStagesView from '../pages/grmin/views/stages.json';
import grminCardsView from '../pages/grmin/views/cards.json';
import grminInlineView from '../pages/grmin/views/inline.json';
import grminBacklogView from '../pages/grmin/views/backlog.json';
import grminSplitView from '../pages/grmin/views/split.json';
import grminCalendarView from '../pages/grmin/views/calendar.json';
import grminDashboardView from '../pages/grmin/views/dashboard.json';

/** Тип запису «Звернення органу» зі сторінками пакета: меню, форми та подання з pages/grmin/. */
export const grminDefinition: IRecordTypeDefinition = {
  ...grminEntity,
  views: assembleViewSet({
      table: grminTableView,
      stages: grminStagesView,
      cards: grminCardsView,
      inline: grminInlineView,
      backlog: grminBacklogView,
      split: grminSplitView,
      calendar: grminCalendarView,
      dashboard: grminDashboardView,
  }),
  form: grminFullForm,
  forms: { full: grminFullForm, context: grminContextForm, mini: grminMiniForm, lookup: grminLookupForm },
  menu: grminMenu,
} as IRecordTypeDefinition;
